import React, { useState } from "react";
import { CPInput } from "../CPInput";
import { CPTextarea } from "../CPTextarea";
import { EstimateBottomSheet } from "../estimate/EstimateBottomSheet";
import {
  WorkspaceAddButton,
  WorkspaceEmpty,
} from "../workspace/WorkspaceChrome";

function money(amount) {
  return `$${Number(amount || 0).toFixed(2)}`;
}

function OtherCostSheet({ onClose, onSubmit }) {
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  async function handleSave() {
    setSaving(true);
    setError("");
    try {
      await onSubmit({ description, amount, note });
      onClose();
    } catch (err) {
      setError(err?.message || "Unable to save this cost.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <EstimateBottomSheet
      title="Add Other Cost"
      onClose={onClose}
      onPrimary={handleSave}
      primaryLabel="Add Cost"
      primaryBusy={saving}
      error={error}
    >
      <CPInput
        label="Description"
        value={description}
        onChange={setDescription}
        placeholder="Dump fee"
        required
      />
      <CPInput
        label="Amount"
        value={amount}
        onChange={setAmount}
        placeholder="0.00"
        type="number"
        inputMode="decimal"
        min="0"
        step="0.01"
        required
      />
      <CPTextarea
        label="Note"
        value={note}
        onChange={setNote}
        placeholder="Optional"
        rows={3}
      />
    </EstimateBottomSheet>
  );
}

/**
 * Active other-cost rows for one project. Persistence stays with the caller.
 */
export function ProjectOtherCostsPane({ rows = [], editable = false, onAdd, onVoid }) {
  const [showAdd, setShowAdd] = useState(false);
  const active = (rows || []).filter((row) => row.is_active !== false);

  async function handleVoid(row) {
    if (!editable) return;
    if (!window.confirm(`Void "${row.description}"?`)) return;
    await onVoid?.(row);
  }

  return (
    <div className="est-section-block" data-testid="project-other-costs">
      {active.length === 0 ? (
        <WorkspaceEmpty>No other costs yet.</WorkspaceEmpty>
      ) : (
        active.map((row) => (
          <div key={row.other_cost_id} className="est-row">
            <div className="est-row-main">
              <div className="est-row-title">{row.description}</div>
              {row.note ? <div className="est-row-meta">{row.note}</div> : null}
            </div>
            <div className="est-row-value">{money(row.amount)}</div>
            {editable && (
              <button
                type="button"
                className="est-home-edit-toggle"
                onClick={() => handleVoid(row)}
              >
                Void
              </button>
            )}
          </div>
        ))
      )}

      {editable && (
        <WorkspaceAddButton first={active.length === 0} onClick={() => setShowAdd(true)}>
          {active.length === 0 ? "+ Add First Other Cost" : "+ Add Other Cost"}
        </WorkspaceAddButton>
      )}

      {showAdd && (
        <OtherCostSheet
          onClose={() => setShowAdd(false)}
          onSubmit={onAdd}
        />
      )}
    </div>
  );
}
